import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faHamburger,
  faFile,
  faTrashAlt,
  faDotCircle,
  faPencilAlt,
  faPlus,
  faLock,
  faCheck,
  faCog,
  faUser,
  faPhoneAlt,
  faChevronDown,
  faArrowLeft,
  faArrowRight,
  faCircle,
  faKeyboard,
  faTimes,
  faPhoneSlash,
  faBars,
  faBriefcase,
  faStar,
  faHeadset,
  faShareSquare,
  faChalkboardTeacher,
  faSave,
  faUsers,
  faHeart as SolidHeart,
  faBookmark as SolidBookmark,
  faThumbsUp as SolidThumbsUp,
  faEdit,
  faExternalLinkAlt,
  faExclamationCircle,
  faFileAlt,
  faCamera,
  faFileUpload,
  faEnvelope,
  faMinus,
  faSearch,
  faTrophy,
  faPaperPlane,
  faBan,
  faUnlock,
} from '@fortawesome/free-solid-svg-icons';

import {
  faHeart,
  faCommentAlt,
  faBookmark,
  faThumbsUp,
  faEye,
  faClock,
  faCalendarAlt,
  faSquare,
  faFile as RegFile,
} from '@fortawesome/free-regular-svg-icons';

library.add(
  faHamburger,
  faFile,
  faTrashAlt,
  faPhoneAlt,
  faDotCircle,
  faPencilAlt,
  faPlus,
  faLock,
  faStar,
  faCheck,
  faCog,
  faUser,
  faChevronDown,
  faCircle,
  faCamera,
  faKeyboard,
  faChalkboardTeacher,
  faUsers,
  faTimes,
  faBars,
  faPhoneSlash,
  faBriefcase,
  faShareSquare,
  faHeart,
  faCommentAlt,
  faBookmark,
  SolidHeart,
  SolidBookmark,
  SolidThumbsUp,
  faThumbsUp,
  faEye,
  faHeadset,
  faEdit,
  faExternalLinkAlt,
  faExclamationCircle,
  faArrowLeft,
  faSave,
  faFileAlt,
  faFileUpload,
  faClock,
  faCalendarAlt,
  faSquare,
  faEnvelope,
  faMinus,
  faSearch,
  faTrophy,
  faPaperPlane,
  faArrowRight,
  faBan,
  faUnlock,
  RegFile,
);
